export default __webpack_public_path__ + "files/be7a481e724d47203afb70f410662035.woff2";